import Vue from 'vue';
import Vuex from 'vuex';
import { defaultSettings, generateHash, nullInteractionMatrix, nullInteractionMatrixSized, nullDefaultSet, nullWeightEntry, nullScoreCard, nullThema, nullMaatregelScore, scoreCardToScoreSet, emptyDialogMessage } from '@/services/common-lib';
import axios from 'axios';
Vue.use(Vuex);
const API_ROOT = '/AMVBtool_v2/api/';
export default new Vuex.Store({
    state: {
        globalMessage: emptyDialogMessage(),
        errorMessage: '',
        currentUser: {},
        availableProjects: [],
        naam: '',
        projectId: 0,
        highestId: 0,
        themas: [],
        maatregelen: [],
        aspecten: [],
        settings: defaultSettings(),
        scoreletter: '',
        scores: [],
        defaults: nullDefaultSet(),
        scorecards: [],
        activeMainViewIndex: 0,
        inTransfer: false,
        transferOk: false,
        hideInteraction: true,
        hideWeights: true
    },
    mutations: {
        setGlobalMessage(state, message) {
            state.globalMessage = message;
        },
        clearGlobalMessage(state) {
            state.globalMessage = emptyDialogMessage();
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        clearErrorMessage(state) {
            state.errorMessage = '';
        },
        setCurrentUser(state, currentuser) {
            state.currentUser = currentuser;
        },
        newProject(state, name = '') {
            state.naam = name;
            state.projectId = 0;
            state.highestId = 0;
            state.themas = [];
            state.maatregelen = [];
            state.aspecten = [];
            state.settings = defaultSettings();
            state.scores = [];
            state.defaults = nullDefaultSet();
            state.scoreletter = '';
            state.scorecards = [];
            state.inTransfer = false;
            state.hideInteraction = false;
            state.hideWeights = false;
        },
        setactiveMainViewIndex(state, value) {
            state.activeMainViewIndex = value;
        },
        setProjectNaam(state, naam) {
            state.naam = naam;
        },
        setProjectId(state, projectId) {
            state.projectId = projectId;
        },
        setHideInteraction(state, isHidden) {
            state.hideInteraction = isHidden;
        },
        setHideWeights(state, isHidden) {
            state.hideWeights = isHidden;
        },
        setAvailableProjects(state, availableProjects) {
            state.availableProjects = availableProjects;
        },
        storeSettings(state, setting) {
            state.settings = setting;
        },
        storeDefaultInteractions(state, interactions) {
            state.defaults.interactions = interactions;
        },
        storeInteractions(state, interactions) {
            if (state.scorecards[0] && state.scorecards[0].data) {
                state.scorecards[0].data.interactions = interactions;
            }
        },
        updateDefaultWeights(state, weights) {
            for (const index in state.defaults.aspectWeights) {
                state.defaults.aspectWeights[index].aspectWeight = weights[index];
            }
            const interactionIndex = state.defaults.aspectWeights.length;
            state.defaults.interactionWeight = weights[interactionIndex];
        },
        updateWeights(state, weights) {
            if (state.scorecards[0] && state.scorecards[0].data) {
                for (const index in state.scorecards[0].data.aspectWeights) {
                    state.scorecards[0].data.aspectWeights[index].aspectWeight = weights[index];
                }
                const interactionIndex = state.scorecards[0].data.aspectWeights.length;
                state.scorecards[0].data.interactionWeight = weights[interactionIndex];
            }
        },
        applyDataSet(state, dataSet) {
            state.naam = dataSet.naam;
            state.projectId = 0;
            state.themas = dataSet.themas;
            state.maatregelen = dataSet.maatregelen;
            state.aspecten = dataSet.aspecten;
            state.defaults = dataSet.defaults; // These may be missing ...
            state.scoreletter = dataSet.scoreletter;
            state.hideInteraction = dataSet.hideInteraction;
            state.hideWeights = dataSet.hideWeights;
            if (dataSet.scores) {
                state.scores = dataSet.scores;
            }
            else {
                state.scores = [];
            }
            state.highestId = 0;
            for (const index in dataSet.themas) {
                if (dataSet.themas[index].id > state.highestId) {
                    state.highestId = dataSet.themas[index].id;
                }
            }
            for (const index in dataSet.maatregelen) {
                if (dataSet.maatregelen[index].id > state.highestId) {
                    state.highestId = dataSet.maatregelen[index].id;
                }
            }
            for (const index in dataSet.aspecten) {
                if (dataSet.aspecten[index].id > state.highestId) {
                    state.highestId = dataSet.aspecten[index].id;
                }
            }
        },
        setScoreLetter(state, letter) {
            state.scoreletter = letter;
        },
        clearScores(state) {
            state.scores = [];
        },
        addScore(state, score) {
            const index = state.scores.findIndex(s => s.fileName == score.fileName);
            if (index >= 0) {
                state.scores.splice(index, 1);
            }
            state.scores.push(score);
        },
        addNewScoreCardByRecipient(state, recipient) {
            const scorecard = {
                id: -1,
                project_id: state.projectId,
                email: recipient.email,
                response_token: recipient.response_token,
                is_complete: false,
                data: state.defaults,
                created_at: '',
                updated_at: ''
            };
            state.scorecards.push(scorecard);
        },
        removeScoreCardById(state, id) {
            const index = state.scorecards.findIndex(card => card.id === id);
            state.scorecards.splice(index, 1);
        },
        removeScoreCardByRecipient(state, recipient) {
            const index = state.scorecards.findIndex(card => card.response_token === recipient.response_token);
            state.scorecards.splice(index, 1);
        },
        // Only clear the local list, do NOT remove them online
        clearScoreCards(state) {
            state.scorecards = [];
        },
        setScoreCards(state, scorecards) {
            state.scorecards = scorecards;
        },
        updateScoreCard(state, scorecard) {
            const index = state.scorecards.findIndex(card => card.response_token === scorecard.response_token);
            state.scorecards[index] = scorecard;
        },
        removeThema(state, id) {
            const index = state.themas.findIndex(storeThema => storeThema.id === id);
            if (index >= 0) {
                state.themas.splice(index, 1);
            }
        },
        removeMaatregel(state, id) {
            const index = state.maatregelen.findIndex(storeMaatregel => storeMaatregel.id === id);
            if (index >= 0) {
                state.maatregelen.splice(index, 1);
                state.defaults.interactions = nullInteractionMatrixSized(state.maatregelen.length);
                for (const aspect of state.defaults.aspectScores) {
                    aspect.maatregelResult.splice(index, 1);
                }
            }
        },
        removeAspect(state, id) {
            const index = state.aspecten.findIndex(storeAspect => storeAspect.id === id);
            if (index >= 0) {
                state.aspecten.splice(index, 1);
                state.defaults.aspectScores.splice(index, 1);
            }
            const wt_index = state.defaults.aspectWeights.findIndex(storeWeight => storeWeight.aspectId == id);
            if (wt_index >= 0) {
                state.defaults.aspectWeights.splice(wt_index, 1);
            }
        },
        removeScore(state, id) {
            const index = state.scores.findIndex(storeScore => storeScore.id === id);
            if (index >= 0) {
                state.scores.splice(index, 1);
            }
        },
        updateThema(state, inThema) {
            const index = state.themas.findIndex(storeThema => storeThema.id === inThema.id);
            if (index >= 0) {
                Vue.set(state.themas, index, inThema);
            }
            else {
                state.themas.push(inThema);
            }
        },
        updateMaatregel(state, inMaatregel) {
            const index = state.maatregelen.findIndex(storeMaatregel => storeMaatregel.id === inMaatregel.id);
            if (index >= 0) {
                Vue.set(state.maatregelen, index, inMaatregel);
            }
            else {
                state.maatregelen.push(inMaatregel);
                // Update the size of the interation matrix
                state.defaults.interactions = nullInteractionMatrixSized(state.maatregelen.length);
                // Add an entry to all existing aspect defaults
                for (const i in state.defaults.aspectScores) {
                    let m = nullMaatregelScore();
                    m.maatregelId = inMaatregel.id;
                    state.defaults.aspectScores[i].maatregelResult.push(m);
                }
            }
        },
        updateAspect(state, inAspect) {
            const index = state.aspecten.findIndex(storeAspect => storeAspect.id === inAspect.id);
            if (index >= 0) {
                Vue.set(state.aspecten, index, inAspect);
            }
            else {
                state.aspecten.push(inAspect);
                const defaultValue = inAspect.answerType === 'options' ? 1 : 0;
                const results = [];
                for (const m of state.maatregelen) {
                    results.push({ maatregelId: m.id, answer: defaultValue, score1to10: defaultValue });
                }
                state.defaults.aspectScores.push({
                    aspectId: inAspect.id,
                    maatregelResult: results
                });
            }
            const wt_index = state.defaults.aspectWeights.findIndex(storeWeight => storeWeight.aspectId === inAspect.id);
            if (wt_index >= 0) {
                // do nothing? (Maybe check valitidy of current value?)
            }
            else {
                let wt = nullWeightEntry();
                wt.aspectId = inAspect.id;
                state.defaults.aspectWeights.push(wt);
            }
        },
        setDefaultAspectScoreValues(state, param) {
            const index = state.aspecten.findIndex(storeAspect => storeAspect.id === param.aspectId);
            if (index >= 0) {
                const isOptions = (state.aspecten[index].answerType === 'options');
                for (let i in state.defaults.aspectScores[index].maatregelResult) {
                    state.defaults.aspectScores[index].maatregelResult[i].answer = param.values[i];
                    if (isOptions) {
                        state.defaults.aspectScores[index].maatregelResult[i].score1to10 = param.values[i];
                    }
                }
            }
        },
        setAspectScoreValues(state, param) {
            const index = state.aspecten.findIndex(storeAspect => storeAspect.id === param.aspectId);
            if (index >= 0 && state.scorecards[0]) {
                const isOptions = (state.aspecten[index].answerType === 'options');
                for (let i in state.scorecards[0].data.aspectScores[index].maatregelResult) {
                    state.scorecards[0].data.aspectScores[index].maatregelResult[i].answer = param.values[i];
                    if (isOptions) {
                        state.scorecards[0].data.aspectScores[index].maatregelResult[i].score1to10 = param.values[i];
                    }
                }
            }
        },
        startTransfer(state) {
            state.inTransfer = true;
            state.transferOk = false;
        },
        stopTransfer(state, succes) {
            state.inTransfer = false;
            state.transferOk = succes;
        }
    },
    actions: {
        getCurrentUser({ commit }) {
            axios.get('auth/current')
                .then(response => {
                if (response.data.user) {
                    commit('setCurrentUser', response.data.user);
                }
            }).catch(function (error) {
                localStorage.clear();
                window.location.replace('/AMVBtool_v2/login');
            });
        },
        loginUser({ commit }, user) {
            commit('clearErrorMessage');
            axios.defaults.baseURL = process.env.VUE_API_ROOT;
            axios.post(API_ROOT + 'auth/login', {
                email: user.email,
                password: user.password
            })
                .then(response => {
                if (response.data.token) {
                    // Save token in localstorage for later use.
                    localStorage.setItem('amvbtool_token', response.data.token);
                    window.location.replace('/AMVBtool_v2/tool');
                }
            })
                .catch(error => {
                commit('setErrorMessage', 'Auth.LoginFailed');
            });
        },
        logoutUser({}) {
            axios.post('auth/logout')
                .then(response => {
                localStorage.clear();
                window.location.replace('/AMVBtool_v2/login');
            })
                .catch(error => {
                console.log(error);
            });
        },
        saveProject({ state, commit }, projectNaam) {
            const currentDataSet = {
                id: generateHash(),
                naam: projectNaam,
                themas: state.themas,
                maatregelen: state.maatregelen,
                aspecten: state.aspecten,
                defaults: state.defaults,
                scoreletter: state.scoreletter,
                scores: state.scores,
                hideInteraction: state.hideInteraction,
                hideWeights: state.hideWeights
            };
            commit('startTransfer');
            if (state.projectId <= 0) {
                // New project
                axios.post('projects', {
                    name: projectNaam,
                    data: JSON.stringify(currentDataSet)
                })
                    .then(response => {
                    if (response.data.project.id) {
                        commit('setProjectId', Number(response.data.project.id));
                        commit('setProjectNaam', projectNaam);
                        commit('stopTransfer', true);
                    }
                    else {
                        commit('stopTransfer', false);
                    }
                })
                    .catch(error => {
                    commit('stopTransfer', false);
                });
            }
            else {
                // Existing project
                // changed PUT -> POST
                axios.post('projects/' + state.projectId, {
                    name: projectNaam,
                    data: JSON.stringify(currentDataSet)
                })
                    .then(response => {
                    commit('setProjectNaam', projectNaam);
                    commit('stopTransfer', true);
                })
                    .catch(error => {
                    commit('stopTransfer', false);
                });
            }
        },
        loadProject({ state, commit, getters }, projectId) {
            commit('startTransfer');
            axios.get('projects/' + projectId)
                .then(response => {
                if (response.data.project) {
                    const newDataset = JSON.parse(response.data.project.data);
                    commit('applyDataSet', newDataset);
                    commit('setProjectNaam', response.data.project.name);
                    commit('setProjectId', response.data.project.id);
                    commit('stopTransfer', true);
                }
                else {
                    commit('stopTransfer', false);
                }
            })
                .catch(error => {
                commit('stopTransfer', false);
            });
        },
        deleteProject({ state, commit }, projectId) {
            commit('startTransfer');
            // changed DELETE -> GET */delete
            axios.get('projects/' + projectId + '/delete')
                .then(response => {
                if (state.projectId == projectId) {
                    commit('setProjectId', 0);
                }
                commit('stopTransfer', true);
            })
                .catch(error => {
                commit('stopTransfer', false);
            });
        },
        loadAvailableProjects({ state, commit }) {
            axios.get('projects')
                .then(response => {
                if (response.data.projects) {
                    commit('setAvailableProjects', response.data.projects);
                }
            })
                .catch(error => {
                console.log(error);
            });
        },
        loadAvailableScoreCards({ state, commit }) {
            if (state.projectId > 0) {
                axios.get('project/' + state.projectId + '/scores/')
                    .then(response => {
                    if (response.data.scores) {
                        const scorecards = [];
                        for (const s of response.data.scores) {
                            const card = {
                                id: s.id || -1,
                                project_id: s.project_id || -1,
                                email: s.email || '',
                                response_token: s.response_token || '',
                                is_complete: s.is_complete || false,
                                data: JSON.parse(s.data) || {},
                                created_at: s.created_at || '',
                                updated_at: s.updated_at || ''
                            };
                            scorecards.push(card);
                        }
                        commit('setScoreCards', scorecards);
                    }
                })
                    .catch(error => {
                    console.log(error);
                });
            }
        },
        sendSingleScoreCard({ state, commit }, param) {
            let scorecard = state.scorecards.find(card => card.response_token === param.recipient.response_token);
            if (scorecard) {
                if (scorecard.id <= 0) {
                    // New card
                    axios.post('scores', {
                        response_token: scorecard.response_token,
                        email: scorecard.email,
                        project_id: scorecard.project_id,
                        is_complete: false,
                        data: JSON.stringify(scorecard.data),
                        letter: param.letter
                    })
                        .then(response => {
                        if (response.data.score && scorecard) {
                            // Update the local list?
                            scorecard.id = response.data.score.id;
                            scorecard.created_at = response.data.score.created_at;
                            scorecard.updated_at = response.data.score.updated_at;
                            commit('updateScoreCard', scorecard);
                        }
                        else {
                            // indicate error?
                        }
                    })
                        .catch(error => {
                        console.log(error);
                    });
                }
                else {
                    // Update existing card (and this resend)
                    // changed PUT -> POST
                    axios.post('scores/' + scorecard.id, {
                        response_token: scorecard.response_token,
                        email: scorecard.email,
                        project_id: scorecard.project_id,
                        is_complete: scorecard.is_complete,
                        data: JSON.stringify(scorecard.data),
                        letter: param.letter
                    })
                        .then(response => {
                        if (response.data.score && scorecard) {
                            // Update the local list.
                            scorecard.id = response.data.score.id;
                            scorecard.created_at = response.data.score.created_at;
                            scorecard.updated_at = response.data.score.updated_at;
                            commit('updateScoreCard', scorecard);
                        }
                    })
                        .catch(error => {
                        console.log(error);
                    });
                }
            }
        },
        deleteScoreCard({ commit }, id) {
            // Deletes an on-line scorecard, but only if needed.
            if (parseInt(id) > 0) {
                // changed DELETE -> GET */delete
                axios.get('scores/' + id + '/delete')
                    .then(response => {
                    commit('removeScoreCardById', parseInt(id));
                })
                    .catch(error => { console.log(error); });
            }
        },
        loadPublicScoreCard({ commit }, response_token) {
            commit('startTransfer');
            axios.get(API_ROOT + 'respondents/' + response_token)
                .then(response => {
                if (response.data) {
                    if (response.data.project) {
                        const newDataset = JSON.parse(response.data.project.data);
                        commit('applyDataSet', newDataset);
                        commit('setProjectId', response.data.project.id);
                    }
                    if (response.data.scores) {
                        let scorecards = [nullScoreCard()];
                        scorecards[0].data = JSON.parse(response.data.scores.data);
                        scorecards[0].is_complete = response.data.scores.is_complete;
                        commit('setScoreCards', scorecards);
                    }
                    commit('stopTransfer', true);
                }
            })
                .catch(error => {
                commit('stopTransfer', false);
            });
        },
        sendPublicScoreCard({ state, commit }, params) {
            commit('startTransfer');
            // changed PUT -> POST
            axios.post(API_ROOT + 'respondents/' + params.response_token, {
                data: JSON.stringify(state.scorecards[0].data),
                is_complete: params.is_complete
            })
                .then(response => {
                if (response.data.score.data) {
                    let scorecards = [nullScoreCard()];
                    scorecards[0].data = JSON.parse(response.data.score.data);
                    scorecards[0].is_complete = response.data.score.is_complete;
                    commit('setScoreCards', scorecards);
                }
                commit('stopTransfer', true);
            })
                .catch(error => {
                commit('stopTransfer', false);
            });
        },
        addScoreCardScore({ state, commit, getters }, id) {
            const scorecard = state.scorecards.find(card => card.id === id);
            const dataset = getters.getDataSet();
            const range = { min: state.settings.scoreRange.min, max: state.settings.scoreRange.max };
            if (scorecard) {
                commit('addScore', scoreCardToScoreSet(scorecard, dataset, range));
            }
        }
    },
    getters: {
        getSettings: (state) => () => {
            return state.settings;
        },
        getNextId: (state) => () => {
            state.highestId = state.highestId + 1;
            return state.highestId;
        },
        getProjectId: (state) => {
            return state.projectId;
        },
        getAvailableProjects: (state) => () => {
            return state.availableProjects;
        },
        getDataSet: (state) => () => {
            const newDataSet = {
                id: generateHash(),
                naam: state.naam,
                themas: state.themas,
                maatregelen: state.maatregelen,
                aspecten: state.aspecten,
                defaults: state.defaults,
                scoreletter: state.scoreletter,
                scores: state.scores,
                hideInteraction: state.hideInteraction,
                hideWeights: state.hideWeights,
            };
            return newDataSet;
        },
        getThema: (state) => (id) => {
            return state.themas.find(thema => thema.id === id);
        },
        getMaatregel: (state) => (id) => {
            return state.maatregelen.find(maatregel => maatregel.id === id);
        },
        getMaatregelIdByNaam: (state) => (naam) => {
            const foundMaatregel = state.maatregelen.find(maatregel => maatregel.naam === naam);
            if (foundMaatregel) {
                return foundMaatregel.id;
            }
            return 0;
        },
        getMaatregelList: (state) => () => {
            const maatregellist = [];
            let row = 1;
            for (const maatregel of state.maatregelen) {
                const thema = state.themas.find(thema => thema.id === maatregel.themaId) || nullThema();
                maatregellist.push({ nr: row++, thema: thema.naam, maatregel: maatregel.naam });
            }
            return maatregellist;
        },
        getAspect: (state) => (id) => {
            return state.aspecten.find(aspect => aspect.id === id);
        },
        getAspectIdByNaam: (state) => (naam) => {
            const foundAspect = state.aspecten.find(aspect => aspect.naam === naam);
            if (foundAspect) {
                return foundAspect.id;
            }
            return 0;
        },
        getScoreSets: (state) => () => {
            return state.scores;
        },
        getDefaultInteractionMatrix: (state) => () => {
            return state.defaults.interactions;
        },
        getInteractionMatrix: (state) => () => {
            if (state.scorecards[0]) {
                return state.scorecards[0].data.interactions;
            }
            return nullInteractionMatrix();
        },
        getDefaultWeights: (state) => () => {
            var values = [];
            for (const aspectIndex in state.aspecten) {
                values.push(state.defaults.aspectWeights[aspectIndex].aspectWeight);
            }
            values.push(state.defaults.interactionWeight);
            return values;
        },
        getWeights: (state) => () => {
            var values = [];
            if (state.scorecards.length > 0) {
                for (const aspectIndex in state.aspecten) {
                    values.push(state.scorecards[0].data.aspectWeights[aspectIndex].aspectWeight);
                }
                values.push(state.scorecards[0].data.interactionWeight);
            }
            return values;
        },
        getDefaultInteractionWeight: (state) => () => {
            return state.defaults.interactionWeight;
        },
        getDefaultAspectScoreValues: (state) => (aspectId) => {
            let values = [];
            const index = state.defaults.aspectScores.findIndex(score => score.aspectId === aspectId);
            if (index >= 0) {
                const isOptions = (state.aspecten[index].answerType === 'options');
                for (const m of state.defaults.aspectScores[index].maatregelResult) {
                    if (isOptions) {
                        values.push(m.score1to10);
                    }
                    else {
                        values.push(m.answer);
                    }
                }
            }
            return values;
        },
        getAspectScoreValues: (state) => (aspectId) => {
            let values = [];
            const index = state.scorecards[0].data.aspectScores.findIndex(score => score.aspectId === aspectId);
            if (index >= 0) {
                const isOptions = (state.aspecten[index].answerType === 'options');
                for (const m of state.scorecards[0].data.aspectScores[index].maatregelResult) {
                    if (isOptions) {
                        values.push(m.score1to10);
                    }
                    else {
                        values.push(m.answer);
                    }
                }
            }
            return values;
        },
        getProjectDefaultsStatusOK: (state) => (repair = false) => {
            // Run a full sanity check on defaults.
            const numAspecten = state.aspecten.length;
            const numMaatregelen = state.maatregelen.length;
            // Check basic dimensions of lists.
            if (state.defaults.aspectWeights.length != numAspecten) {
                return false;
            }
            if (state.defaults.interactions.size != numMaatregelen) {
                return false;
            }
            if (state.defaults.interactions.cells.length != numMaatregelen * numMaatregelen) {
                return false;
            }
            if (state.defaults.aspectScores.length != numAspecten) {
                return false;
            }
            for (const asc of state.defaults.aspectScores) {
                if (asc.maatregelResult.length != numMaatregelen) {
                    return false;
                }
            }
            // Look at content. Note: repair assumes project is sane and valid.
            for (const a_idx in state.aspecten) {
                if (state.defaults.aspectScores[a_idx].aspectId !== state.aspecten[a_idx].id) {
                    if (!repair) {
                        return false;
                    }
                    state.defaults.aspectScores[a_idx].aspectId = state.aspecten[a_idx].id;
                }
                if (state.defaults.aspectWeights[a_idx].aspectId !== state.aspecten[a_idx].id) {
                    if (!repair) {
                        return false;
                    }
                    state.defaults.aspectWeights[a_idx].aspectId = state.aspecten[a_idx].id;
                }
                for (const m_idx in state.maatregelen) {
                    if (state.defaults.aspectScores[a_idx].maatregelResult[m_idx].maatregelId !== state.maatregelen[m_idx].id) {
                        if (!repair) {
                            return false;
                        }
                        state.defaults.aspectScores[a_idx].maatregelResult[m_idx].maatregelId = state.maatregelen[m_idx].id;
                    }
                }
            }
            return true;
        },
        getRecipients: (state) => () => {
            const recipients = [];
            for (const s of state.scorecards) {
                let updatetime = '';
                let sentstatus = 'OnlineDistributie.NietVerstuurd';
                if (s.updated_at !== '' && s.id > 0) {
                    updatetime = new Date(s.updated_at).toLocaleString('en');
                    sentstatus = 'OnlineDistributie.VerstuurdOp';
                }
                recipients.push({
                    email: s.email,
                    response_token: s.response_token,
                    sentstatus: sentstatus,
                    updatetime: updatetime
                });
            }
            return recipients;
        },
        getScoreCardByRecipient: (state) => (recipient) => {
            return state.scorecards.find(card => card.response_token === recipient.response_token);
        }
    }
});
